import { Component, OnInit } from '@angular/core';
import { CropDetails } from '../../../Models/AdminRights/crop-details';
import { MatSnackBarComponent } from "../../mat-snack-bar/mat-snack-bar.component";
import { AdminRightsService } from '../../../Services/AdminRights/admin-rights.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-crop-config',
  templateUrl: './crop-config.component.html',
  styleUrls: ['./crop-config.component.css']
})
export class CropConfigComponent implements OnInit {
  loader = 'none';
  roleId: string;
  userId: string;
  cropDetails: CropDetails[] = [];
  // saveCropDetails: CropDetails[] = [];
  saveCropDetails: CropDetails = new CropDetails();

  constructor(private adminConfiguration: AdminRightsService, private toastr: ToastrService) {
    this.userId = localStorage.getItem('dsu_userId');
    this.roleId = localStorage.getItem('dsu_roleCode');
  }
  ngOnInit() {
    this.getCropDetails();
  }
  getCropDetails() {
    this.loader = 'block';
    this.adminConfiguration.getCropDetails(this.userId, this.roleId)
      .subscribe((cropdata) => {
        this.cropDetails = cropdata.data;
        this.loader = 'none';
      });

  }
  changeStatus(cropName, cropGroupID) {
  }
  cancelStatus() {
    this.getCropDetails();

  }
  updateStatus(saveCropDetails) {
    let isAllStatusFalse = saveCropDetails.some((element) => element.status == true)
    if (!isAllStatusFalse) {
      this.toastr.error('Please select atleast one crop.');
      this.loader = 'none';
    } else {
      this.loader = 'block';

      this.adminConfiguration.updateCropDetails(saveCropDetails, this.userId, this.roleId)
        .subscribe(res => {
          if (res.message == "Success") {
            this.toastr.success('Data Saved Successfully.');
            this.loader = 'none';
          }
          else {
            this.toastr.error(res.message);
            this.loader = 'none';
          }
        });
    }

  }
  allCrops()
  {
      this.cropDetails.forEach((item)=>item.status=true);
    
  
    //this.saveCropDetails.Status=true;
    
  }

}
